import { Action, ActionReducer } from '@ngrx/store';

interface ICommonReducer<T, T2> {
  reducer: ActionReducer<T, Action>;
  featureKey: T2;
}

export function addNestedReducer<TState, T, T2 extends keyof TState>(
  state: TState,
  action: Action,
  data: ICommonReducer<T, T2>,
): TState {
  return {
    ...state,
    [data.featureKey]: data.reducer(state[data.featureKey] as T, action),
  };
}
